import React from "react"

function IconTrash({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="trash"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-trash"
      {...props}
    >
      <path
        d="M15.127 2.516c.501 0 .914.375.975.86l.007.122v2.517h5.031a.655.655 0 0 1 .106 1.301l-.106.009h-1.379v12.28c0 .91-.697 1.658-1.587 1.739l-.158.007H6.17c-.91 0-1.658-.697-1.738-1.587l-.007-.159-.001-12.28H2.906a.655.655 0 0 1-.106-1.3l.106-.01h4.88l.001-2.517c0-.5.375-.913.859-.974l.123-.008h6.358zm3.324 4.808H5.734l.001 12.281c0 .18.11.336.267.402l.081.026.088.009h11.845c.21 0 .386-.15.427-.349l.009-.088-.001-12.28zm-8.42 3.04c.326 0 .596.237.647.548l.008.106v5.61a.655.655 0 0 1-1.3.107l-.009-.106v-5.61c0-.362.293-.655.655-.655zm4.208 0c.326 0 .596.237.646.548l.009.106v5.61a.655.655 0 0 1-1.3.107l-.01-.106v-5.61c0-.362.294-.655.655-.655zm.56-6.538H9.097v2.189H14.8V3.826z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconTrash
